<div class="blink-container">
  <u-icon [model]="model" [styles]="{ color: backgroundColor, fontSize: icon1FontSize }"></u-icon>
  <u-icon [model]="model" [styles]="{ color: backgroundColor, fontSize: icon2FontSize }"></u-icon>
</div>
